import * as React from "react";
import { SVGProps } from "react";

const Digibyte = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 479 479" {...props}>
    <circle
      cx={239.9}
      cy={239.9}
      r={219.5}
      fill="#002352"
      stroke="#06c"
      strokeMiterlimit={10}
      strokeWidth={40.8}
    />
    <path
      fill="#fff"
      d="M116.9 182.9h155s53.5-.5 16.5 68.5c0 0-27 54-94 53l36.1-92.2a7.3 7.3 0 0 0-6.6-10l-47.5-.8-60 146s20 2 31 1l-6 15h28.3a3.8 3.8 0 0 0 3.6-2.5l5.1-13.5 12-1-7 17H211a5 5 0 0 0 4.7-3.2l7.7-19.8s84-14 122-82c0 0 51-79-9-107a116 116 0 0 0-37-10l7-17.3a3.4 3.4 0 0 0-3.1-4.7h-25.9l-8 21h-11l6.2-16.3a3.5 3.5 0 0 0-3.2-4.7h-26l-8 21h-80.8a12 12 0 0 0-10.6 6.3z"
    />
  </svg>
);

export default Digibyte;
